import { FC, PropsWithChildren } from 'react';

export const GlobalRotation: FC<PropsWithChildren> = ({ children }) => {
    // We apply global rotation to translate the difference between y-up and z-up systems.
    // Our analysis and three.js use different coordinate systems, this rotation allows us to use coordinates from analysis as-is.
    return <group rotation={[-Math.PI / 2, 0, -Math.PI / 2]}>{children}</group>;
};
